// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"328":"reset_password","644":"account","651":"simuam","966":"login"}[chunkId] + "." + {"328":"15d2700a","644":"e8c7d6f5","651":"b2fbaa58","966":"0cdc4811"}[chunkId] + ".js";
};